module.exports = __webpack_public_path__ + "static/media/product01.7ec9b863.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/product01.png
// module id = 67
// module chunks = 0